<template>
    <div class="blocker-wrapper">
        <div class="overlay">

        </div>
        <div class="blocker-inner">
            <i class="fa fa-lock"></i>
            <h2>{{ $t('global.isBlocked2.title') }}</h2>
            <p v-html="$t('global.isBlocked2.content')">
                Votre compte est vérouillé et nécessite une action administrative pour être actif à nouveau.
                <br><br>
                Veuillez prendre contact avec le service administratif Beepiz (+33247411010).
            </p>
                <br><br>
                <Btn :class="'primary reverse'" @click.native.prevent="onLogoutHandler">
                    {{ $t('nav.logout') }}
                </Btn>
        </div>
    </div>
</template>

<script>
    //import Component from 'path/to/component'
    import Btn from '@/components/ui/Button'

    export default {
        beforeCreate: function () {

        },
        beforeDestroy: function () {

        },
        beforeMount: function () {

        },
        beforeUpdate: function () {

        },
        components: {
            Btn
        },
        computed: {},
        created: function () {

        },
        data() {
            return {}
        },
        destroyed: function () {

        },
        methods: {
            onLogoutHandler(){
                this.$router.replace({name:'Logout'})
                window.Vfc.showBlocker(false)
            }
        },
        mounted: function () {

        },
        name: 'Blocker',
        props: {},
        updated: function () {

        },
        watch: {}
    }
</script>

<style lang="scss" scoped>

</style>
